import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ReactLenis, useLenis } from "lenis/react";
import Preloader from "@/components/Preloader";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import Project from "@/pages/Project";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Process from "@/pages/Process";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-lak-bg text-lak-text">
        <ReactLenis root options={{ duration: 1.05, smoothWheel: true, smoothTouch: false, touchMultiplier: 1.8, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) }}>
          <BrowserRouter>
            <ScrollToTop />
            <Preloader />
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/work" element={<Work />} />
              <Route path="/work/petal-and-paw" element={<Project />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/process" element={<Process />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <Toaster position="bottom-center" theme="light" />
          </BrowserRouter>
        </ReactLenis>
      </div>
    </HelmetProvider>
  );
}

export default App;
